/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class TenantStoreEvents {
}
TenantStoreEvents.ITEM_ADDED_EVENT = 'dell.sirius.store.item-added';
TenantStoreEvents.ITEM_UPDATED_EVENT = 'dell.sirius.store.item-updated';
TenantStoreEvents.ITEM_REMOVED_EVENT = 'dell.sirius.store.item-removed';
TenantStoreEvents.ITEM_EVICTED_EVENT = 'dell.sirius.store.item-evicted';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVuYW50LXN0b3JlLWV2ZW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zaGFyZWQvdGVuYW50LXN0b3JlL2V2ZW50cy90ZW5hbnQtc3RvcmUtZXZlbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGlCQUFpQjs7QUFDSCxrQ0FBZ0IsR0FBRyw4QkFBOEIsQ0FBQztBQUNsRCxvQ0FBa0IsR0FBRyxnQ0FBZ0MsQ0FBQztBQUN0RCxvQ0FBa0IsR0FBRyxnQ0FBZ0MsQ0FBQztBQUN0RCxvQ0FBa0IsR0FBRyxnQ0FBZ0MsQ0FBQyJ9